import { render } from "./OttvoucherDepositWebsite.vue?vue&type=template&id=57cc748e&scoped=true"
import script from "./OttvoucherDepositWebsite.vue?vue&type=script&lang=js"
export * from "./OttvoucherDepositWebsite.vue?vue&type=script&lang=js"

import "./OttvoucherDepositWebsite.vue?vue&type=style&index=0&id=57cc748e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57cc748e"]])

export default __exports__